import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@MasterBluePrint/Widgets/RfqMyQuotes/SearchTextField";
import * as React from "react";

export const quoteSearchFieldAmountStyles: SearchTextFieldStyles = {};
const styles = quoteSearchFieldAmountStyles;

const QuoteSearchFieldAmount: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            testSelector="quote_filterAmount"
            styles={styles}
            parameterField="amount"
            label="Amount"
            inputType="number"
            placeholder="Type a number"
        />
    );
};

const widgetModule: WidgetModule = {
    component: QuoteSearchFieldAmount,
    definition: {
        group: "RFQ My Quotes",
        displayName: "Amount",
    },
};

export default widgetModule;
